export default "__VITE_ASSET__CXgZBV3R__"